<template>
  <CusModal
    @handleCancel="onClose"
    @handleOk="onClickConfirm"
    :title="$t('timeSheets.compensatory_timesheet')"
    :isShow="open"
  >
    <div class="card-modal-infomation">
      <div class="card-modal-warning">
        <img src="/img/icons/warning-icon.svg" alt=""/>
        <div class="card-modal-warning-label">
          {{ $t("timeSheets.warning") }}
        </div>
      </div>
      <div class="card-modal-calculate">
        <div class="card-modal-dayoff card-modal-dayoff-up">
          <div class="card-modal-dayoff-label">{{$t("additional_timeSheet.sabatical_date_available")}}</div>
          <div class="card-modal-dayoff-quantity number-day-off">
            {{ numberOfDaysLeaveAvailable }} {{ $t("overtime.date_lowercase") }}
          </div>
        </div>
        <div class="card-modal-dayoff">
          <div class="card-modal-dayoff-label">
            {{ $t("timeSheets.missing_timesheet") }}
          </div>
          <div class="card-modal-dayoff-quantity number-miss">
            {{ missTimesheet }} {{ $t("overtime.date_lowercase") }}
          </div>
        </div>
      </div>

      <div class="card-modal-option">
        <div class="card-modal-select">
          <div class="card-modal-option-text">
            {{ $t("timeSheets.label_use") }}
            <input
              v-model="compensationValue"
              type="text"
              placeholder=""
              class="input-option"
            />{{$t("additional_timeSheet.sabatical_date")}}
          </div>
        </div>
      </div>
      <div class="input-option--err" v-if="error">
        {{$t("additional_timeSheet.error_input")}}
      </div>
    </div>
  </CusModal>
</template>

<script>
import CusModal from "@/components/commons/CusModal.vue";

export default {
  props: {
    open: {
      type: Boolean
      // required: true
    },
    missTimesheet: {
      type: Number
    },
    numberOfDaysLeave: {
      type: Number
    },
    numberOfDaysLeaveAvailable: {
      type: Number
    },
  },
  components: {
    CusModal
  },
  data() {
    return {
      compensationValue: "",
      error: false
    };
  },

  watch: {
    compensationValue() {
      this.validateCompensation();
    },
    open() {
      if(this.open) {
        this.compensationValue = this.missTimesheet >= this.numberOfDaysLeaveAvailable
          ? this.numberOfDaysLeaveAvailable
          : this.missTimesheet;
      }
    }
  },
  methods: {
    onClickConfirm() {
      this.validateCompensation();
      if (this.error) return;
      this.$emit("confirm", this.compensationValue);
      // this.error = false;
      // this.compensationValue = "";
    },
    onClose() {
      // this.error = false;
      // this.compensationValue = "";
      this.$emit("close");
    },
    validateCompensation() {
      let isError = true;
      if (
        this.compensationValue <= this.numberOfDaysLeaveAvailable &&
        this.compensationValue <= this.missTimesheet &&
        this.compensationValue > 0
      ) {
        isError = false;
        if (this.countDecimal(this.compensationValue) > 2) {
          isError = true;
        }
      }

      this.error = isError;
    },
    countDecimal(number) {
      if (number.toString().includes(".")) {
        return number.toString().split(".")[1].length || 0;
      }
      return 0;
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.card-modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: 1030;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
}
.card-modal-inner {
  max-width: 700px;
  max-height: 270px;
  margin: 2rem auto;
}

.card-modal-content {
  position: relative;
  background-color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.3);
  background-clip: padding-box;
  border-radius: 10px;
  margin-top: 50%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.drop-in-enter-active,
.drop-in-leave-active {
  transition: all 0.3s ease-out;
}

.drop-in-enter-from,
.drop-in-leave-to {
  opacity: 0;
  transform: translateY(-50px);
}
.card-modal-title {
  border-bottom: 1px solid #3d4cdc;
  padding: 12px;
  display: flex;
  background: #d2d6ff;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  display: flex;
}

.card-modal-warning-icon {
  margin-bottom: 5px;
}

.card-modal-label {
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  color: #3d4cdc;
}

.card-modal-button {
  margin-left: auto;
  font-size: 18px;
  font-weight: 800;
  line-height: 18px;
}

.card-modal-action {
  text-align: center;
  padding: 12px;
}

.btn-submit-timesheet {
  margin-right: 15px;
  width: 200px;
  height: 40px;
  background: #3d4cdc;
  border-radius: 10px;
  color: white;
  border: none;
  outline: none !important;
  font-weight: 700;
}

.btn-cancel-timesheet {
  width: 200px;
  height: 40px;
  background: #ececec;
  border-radius: 10px;
  border: none;
  color: #6f6f6f;
  outline: none !important;
  font-weight: 700;
}

/* .card-modal-infomation {
  padding: 12px;
} */
.card-modal-warning {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  text-align: center;
  display: flex;
  justify-content: center;
}

.card-modal-warning-label {
  margin-left: 10px;
  margin-top: 1px;
}

.card-modal-dayoff {
  display: flex;
  width: 210px;
  margin: 0 auto;
  padding: 10px 0;
}
.card-modal-calculate {
  margin-top: 20px;
}

.card-modal-dayoff-quantity {
  margin-left: auto;
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #8492a6;
}

.card-modal-dayoff-up {
  border-bottom: 1px solid #dde2e5;
}

.label-dayoff {
  color: #118fa6;
  font-weight: 700;
}

.label-missing_timesheet {
  color: #f58722;
  font-weight: 700;
}
.card-modal-dayoff-label {
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
}

.card-modal-select {
  width: 200px;
  display: flex;
  line-height: 14px;
  padding: 5px 0px;
}

.card-modal-option {
  margin-top: 10px;
  display: flex;
  justify-content: center;
}

.card-modal-select input {
  margin-right: 5px;
  font-size: 14px;
}

.card-modal-button {
  cursor: pointer;
}

.card-modal-option-text {
  display: flex;
  font-weight: 500;
  font-size: 14px;
  text-align: center;
  height: 30px;
  line-height: 30px;
}

.input-option {
  width: 60px;
  height: 35px;
  margin: 0px 5px;
  text-align: center;
  background: #ffffff;
  border: 1px solid #dde2e5;
  border-radius: 10px;
  outline: none;
}
.input-option--err {
  color: #ff5253;
  text-align: center;
}

.label-dayoff-text {
  margin: 0px 5px;
}

.number-day-off {
  color: #17a896;
  font-weight: 700;
}

.number-miss {
  color: #ff5253;
  font-weight: 700;
}
</style>
